export const TIME_OFF_REASONS_QUERY_KEY = 'timeOffReasons'
